import * as prismicH from '@prismicio/client'
import { CenterBox } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { FC } from 'react'
import { JumpMenu } from '../HomepageStaticContent/types'
import { RichText, RichTextBlock } from 'prismic-reactjs'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { addScrollMarginTop } from '../../../utils/addScrollMarginTop'
import Link from 'next/link'
import PrismicText from '@app/prismic/src/components/PrismicText/PrismicText'
import events from '@dtx-company/inter-app/src/event-tracking/events/homepage'
import styled from 'styled-components'

export const HomepageTopBanner: FC<{
  jumpMenu?: JumpMenu
  header?: RichTextBlock[]
  backgroundColor?: string
  display?: string
}> = ({ header, backgroundColor, display, jumpMenu }) => {
  const defaultBackgroundColor = jumpMenu ? '#006d3d' : 'primary.flowBlue'

  return (
    <CenterBox
      data-testid="homepage-top-banner"
      padding="8px"
      width="100%"
      bg={backgroundColor ? backgroundColor : defaultBackgroundColor}
      display={display}
    >
      <HeaderContainer>
        <>
          {jumpMenu &&
            jumpMenu.items.map(item => (
              <Link
                key={item.section_id[0]?.text}
                href={{ hash: item.section_id[0]?.text || '' }}
                onClick={() => {
                  events.Flowcode_LoggedOutGenerator_Clicked_TopBannerText({
                    linkText: prismicH.asText(item.section_title)
                  })
                  addScrollMarginTop(item.section_id[0]?.text)
                }}
                data-testid="homepage-banner-link"
              >
                <PrismicText
                  textAlign="center"
                  textDecoration={'underline'}
                  richTextField={item.section_title}
                  variant="body/medium"
                  color="primary.white"
                  fontWeight={'bold'}
                />
              </Link>
            ))}
          {header && (
            <Text
              onClick={() =>
                events.Flowcode_LoggedOutGenerator_Clicked_TopBannerText({
                  linkText: RichText.asText(header)
                })
              }
              textAlign="center"
              as={'div'}
              variant="body/medium"
              color="primary.white"
              data-testid="homepage-banner-header"
            >
              {RichText.render(header)}
            </Text>
          )}
        </>
      </HeaderContainer>
    </CenterBox>
  )
}

const HeaderContainer = styled.div`
  p {
    margin: 0;
  }

  a {
    text-decoration: underline;
  }
`
